/**
 * Provides methods for checking the type of variables.
 * e.g.
 * isArray(someVar);
 * isFunction(someVar);
 */

/**
 * @param {*} object
 * @return {boolean}
 */
const isArray = (object) => {
    return object instanceof Array;
};

/**
 * @param {*} object
 * @return {boolean}
 */
const isFunction = (object) => {
    return typeof object === 'function';
};

/**
 * @param {*} object
 * @return {boolean}
 */
const isNumber = (object) => {
    return typeof object === 'number';
};

/**
 * @param {*} object
 * @return {boolean}
 */
const isObject = (object) => {
    // This can be improved to check for objects only (and not null or arrays) as:
    // return object != null && object.constructor.name === 'Object';
    // But it would break too much of the app, so stick with using this:
    return object !== null && typeof object === 'object';
};

/**
 * @param {*} object
 * @return {boolean}
 */
const isString = (object) => {
    return typeof object === 'string';
};

module.exports = {
    isArray,
    isFunction,
    isNumber,
    isObject,
    isString,
};
